module.exports = __webpack_public_path__ + "img/instagram.04f1d872.svg";